import { render, staticRenderFns } from "./LoginV3.vue?vue&type=template&id=58aea8f8&scoped=true&"
import script from "./LoginV3.vue?vue&type=script&lang=js&"
export * from "./LoginV3.vue?vue&type=script&lang=js&"
import style0 from "./LoginV3.vue?vue&type=style&index=0&id=58aea8f8&prod&lang=scss&"
import style1 from "./LoginV3.vue?vue&type=style&index=1&id=58aea8f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aea8f8",
  null
  
)

export default component.exports